module.exports = __webpack_public_path__ + "static/img/PastedGraphic-7@2x.b9ef63c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/PastedGraphic-7@2x.png
// module id = j16n
// module chunks = 1